let newsSortBy=document.querySelector('#newsSortBy');
let formSortBy=document.querySelector('#frmSubmit');

// let newsCategories=document.querySelector('#newsCategories');
newsSortBy.addEventListener("change", function(event){
    formSortBy.submit();
});

// newsCategories.addEventListener("change", function(event){
//     formSortBy.submit();
// });